// @flow
import type {
  ResetPasswordOperator,
  ResetPasswordOperation,
} from '../../types'

// Action Types
import {
  URL_RESET_PASSWORD,
  RESET_PASSWORD,
} from 'fc-auth/src/constants'

// Effect Managers
import { call, put, select, take } from 'redux-saga/effects'

// Request Reset Operator
import resetPasswordOperator from '../resetPasswordOperator'

// Selectors
import resetPasswordOperation$ from '../selectors/resetPasswordOperation'

// Utils
import { __post } from 'hfty-fetch'

// Exports
export default function *watchResetPassword (): Generator<*, *, *> {
  const operator: ResetPasswordOperator = resetPasswordOperator()
  const operation = operator.create({
    model: { token: '', password: '' },
  })

  yield put(operator.actionCreators.add(operation))

  while (true) {
    yield take(RESET_PASSWORD)

    const resetPasswordOperation: ResetPasswordOperation = yield select(resetPasswordOperation$)

    yield put(operator.actionCreators.updateOperation({
      ...resetPasswordOperation,
      errors: [],
      submitting: true,
    }))


    // Obtain url from browser address bar
    const token = document.location.href.split('reset/')[1]
    const model = {
      ...resetPasswordOperation.model,
      token,
    }

    const newOperation = {
      ...operation,
      model,
    }

    const nextOperation = yield call(handleSubmitOperation, newOperation, operator)

    const action = operator.actionCreators.updateOperation(nextOperation)
    yield put(action)
  }
}

export function *handleSubmitOperation (
  operation: ResetPasswordOperation,
  operator: ResetPasswordOperator): Generator<*, ResetPasswordOperation, *> {
  try {
    const response = yield call(__post, {
      path: URL_RESET_PASSWORD,
      body: operation.model,
      excludeToken: true,
    })
    if (response.status >= 200 && response.status < 300) {
      const nextOperation = {
        ...operation,
        submitting: false,
        success: true,
      }
      const action = operator.actionCreators.updateOperation(nextOperation)
      yield put(action)

      return nextOperation
    } else {
      const { statusText, status } = response
      let errors = { status: `${status} - ${statusText}` }
      if (status === 400) {
        errors = { expiredPasswordLink: 'expiredPasswordLink' }
      }
      const nextOperation = {
        ...operation,
        submitting: false,
        success: false,
        errors: [errors],
      }

      const action = operator.actionCreators.updateOperation(nextOperation)
      yield put(action)

      return nextOperation
    }
  } catch (e) {
    console.warn('There has been an error resetting your password.')
  }
}
